import * as React from "react";
import { DocumentTitle, Spinner } from "components/common";
import WizardPageHeader from "components/authentication/directoryServices/ldap/WizardPageHeader";
import SectionComponent from "components/common/Section/SectionComponent";
import LicenseCheck from "license/LicenseCheck";
import getDisplayName from "authentication/helpers/getDisplayName";
import SAMLBackendConfigWizard from "authentication/components/saml/config/SAMLBackendConfigWizard";
import { fromAuthenticationBackend } from "authentication/components/saml/config/helpers/samlConfigConverter";
import useSAMLTeamSyncConfig from "authentication/components/saml/hooks/useSAMLTeamSyncConfig";
const SAMLBackendEdit = ({ authenticationBackend, initialStepKey }) => {
  const { isLoading, teamSyncBackend } = useSAMLTeamSyncConfig(authenticationBackend.id);
  if ((authenticationBackend == null ? void 0 : authenticationBackend.id) && isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const {
    config: { type: authServiceType }
  } = authenticationBackend;
  const title = `Edit ${getDisplayName(authServiceType)} Authentication Service`;
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title }, /* @__PURE__ */ React.createElement(WizardPageHeader, { authenticationBackend }), /* @__PURE__ */ React.createElement(SectionComponent, { title }, /* @__PURE__ */ React.createElement(LicenseCheck, null, ({ licenseIsValid }) => /* @__PURE__ */ React.createElement(
    SAMLBackendConfigWizard,
    {
      authBackend: fromAuthenticationBackend(authenticationBackend, teamSyncBackend),
      initialStep: initialStepKey,
      licenseIsValid
    }
  ))));
};
export default SAMLBackendEdit;
